import { render, staticRenderFns } from "./editClassifyDialog.vue?vue&type=template&id=1ddf9645&scoped=true"
import script from "./editClassifyDialog.vue?vue&type=script&lang=js"
export * from "./editClassifyDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddf9645",
  null
  
)

export default component.exports